export default "__VITE_ASSET__aKTENEkv__"